import { Component, DestroyRef, Input, OnInit, inject } from '@angular/core';
import { takeUntilDestroyed } from '@angular/core/rxjs-interop';
import { AbstractControl, FormControl, FormGroup, ReactiveFormsModule, Validators } from '@angular/forms';
import { marker as extractTranslation } from '@colsen1991/ngx-translate-extract-marker';
import { TranslateModule } from '@ngx-translate/core';
import {
  PasswordStrength,
  STRONG_PASSWORD_CHECK,
  getPasswordStrength,
  strongPasswordValidator,
} from './password-strength.utils';

@Component({
  selector: 'nk-password-strength',
  imports: [TranslateModule, ReactiveFormsModule],
  templateUrl: 'password-strength.component.html',
})
export class PasswordStrengthComponent implements OnInit {
  @Input() public showErrors = false;
  @Input({ required: true }) public passwordFormGroup!: FormGroup<{ password: AbstractControl }>;
  @Input() public label = extractTranslation('password.label');
  public password = '';
  public passwordValidators: (keyof typeof STRONG_PASSWORD_CHECK)[] = [
    'lowerCaseLetter',
    'upperCaseLetter',
    'number',
    'specialChar',
  ];
  public passwordStrength: PasswordStrength | undefined;
  public strengthColor: 'success' | 'warning' | 'danger' | undefined;
  private _destroy = inject(DestroyRef);

  public ngOnInit(): void {
    // !important Angulars password validation empties when it is valid. So we use our own.
    // We want to print out password strength even when all requirements are met.
    // However we still want a validator of min requirements met so we can avoid submit.
    this.passwordFormGroup.addControl(
      'password',
      new FormControl(this.password, [Validators.required, Validators.minLength(8), strongPasswordValidator()]),
    );
    this.passwordStrength = getPasswordStrength('');
    this.passwordFormGroup.controls.password.valueChanges.pipe(takeUntilDestroyed(this._destroy)).subscribe((x) => {
      this.passwordStrength = getPasswordStrength(x);
      const requirementsMet = this.passwordStrength.requirementsMet;
      if (requirementsMet > 3) {
        this.strengthColor = 'success';
      } else if (requirementsMet > 2) {
        this.strengthColor = 'warning';
      } else {
        this.strengthColor = 'danger';
      }
    });
  }
}
